<template style="height: 100%;">
    <div style="height: 100%;display: flex" id="homeBox">
        <div class="left" v-if="showTree"  :style="{height: tableHeight+100+'px',minWidth: '300px',overflowY: 'auto'}">
            <left-tree @showData="showData"></left-tree>

<!--            <tab-tree @getValue="getValue" @applicationList="applicationList"  style="background-color: red"> </tab-tree>-->
        </div>
        <div ref="right" style="width: 83%">

        <div  style="display: flex">
            <div style="display: flex;">
                <el-button style="font-size: 1.571rem;height: 2.857rem" type="text"  @click="closeTree" v-show="isright" icon="el-icon-s-fold"></el-button>
                <el-button style="font-size: 1.571rem;height: 2.857rem" type="text" @click="openTree" v-show="!isright" icon="el-icon-s-unfold"></el-button>
            </div>
            <div class="df">
            <div style="display:flex;;">
                <el-button type="text" style="height: 2.857rem;margin-right: 20px"  icon="el-icon-plus"  @click="add">新增</el-button>
<!--                <el-button type="text" style="height: 2.857rem" icon="el-icon-document"  @click.stop="workovertime">加班统计</el-button>-->

                <el-button type="text" style="height: 2.857rem" icon="el-icon-document"  @click.stop="monthovertime">月度统计</el-button>

            </div>
            <div style="display:flex;;">
<!--                <el-select @change="kqdataChange" style="width: 30%;" size="mini" v-model="kqdata" slot="prepend" placeholder="请选择">-->
<!--                    <el-option v-for="val in kaoqinList" :key="val.i_id" :label='val.vc_tcname' :value="val.vc_tcname"></el-option>-->
<!--                </el-select>-->
                <el-date-picker
                        @input="dateSearch"
                        value-format="yyyy-MM"
                        format="yyyy-MM"
                        size="mini"
                        class="input"
                        v-model="dateMonth"
                        type="month"
                        placeholder="选择月"
                >
                </el-date-picker>
                <el-input
                        @input="peopleSearch"
                        size="mini"
                        class="input"
                        placeholder="请输入人员或假别"
                        v-model="peopleSearchdata"
                        clearable>
                </el-input>
            </div>
            </div>
        </div>
        <el-table
                ref="table"
                :height="tableHeight"
                highlight-current-row
                row-key="id"
                :data="tableData"
                border>
<!--            <el-table-column type="expand">-->
<!--                <template slot-scope="props">-->
<!--                    <el-table size="mini" style="width: 100%;background: none" :data="props.row.children">-->
<!--                        <el-table-column label="序号" type="index" width="70">-->
<!--                        </el-table-column>-->
<!--                        <el-table-column label="假别" prop="jbTag">-->
<!--                        </el-table-column>-->
<!--                        <el-table-column label="开始时间" prop="startTime">-->
<!--                        </el-table-column>-->
<!--                        <el-table-column label="结束时间" prop="endTime">-->
<!--                        </el-table-column>-->
<!--                        <el-table-column label="天数" prop="days">-->
<!--                        </el-table-column>-->
<!--                    </el-table>-->
<!--                </template>-->
<!--            </el-table-column>-->
            <el-table-column
                    prop="code"
                    label="编号"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="userName"
                    label="姓名"
                    show-overflow-tooltip>
                <template  slot-scope="props">
                    {{props.row.userName}}{{props.row.departmentName==''?props.row.departmentName:''}}
                </template>
            </el-table-column>
            <el-table-column
                    width="55"
                    prop="jbString"
                    label="假别"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="allDays"
                    label="时长"
                    width="55"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    width="55"
                    prop="unit"
                    label="单位"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                prop="startTime"
                label="开始时间"
                show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="endTime"
                    label="结束时间"
                    show-overflow-tooltip>
            </el-table-column>
<!--            <el-table-column-->
<!--                    prop="f_formoney"-->
<!--                    label="加班结转(工资)"-->
<!--                    show-overflow-tooltip>-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--                    prop="f_repair"-->
<!--                    label="加班结转(出勤)"-->
<!--                    show-overflow-tooltip>-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--                    prop="f_clear"-->
<!--                    label="加班结转(清零)"-->
<!--                    show-overflow-tooltip>-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--                    prop="vc_lruname"-->
<!--                    label="创建人"-->
<!--                    show-overflow-tooltip>-->
<!--            </el-table-column>-->
<!--            <el-table-column-->
<!--                prop="editor"-->
<!--                label="编辑人"-->
<!--                show-overflow-tooltip>-->
<!--        </el-table-column>-->
            <el-table-column
                prop="note"
                :label="$t('form_notes')"
                show-overflow-tooltip>
        </el-table-column>
            <el-table-column
                    prop="stateTxt"
                    label="状态"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <span :class="[scope.row.state==1?'dtj':scope.row.state==2?'tg':scope.row.state==3?'spz':scope.row.state==4?'wtg':scope.row.state==5?'yzfs':'']">{{scope.row.stateTxt}}</span>
                </template>
            </el-table-column>

            <el-table-column
                    width="100"
                    label="操作">
                <template slot-scope="scope">
                    <div v-if="scope.row.state==1&&scope.row.vc_from=='ERP'&&scope.row.type!=4&&scope.row.type!=5">
<!--                        <el-button  type="text" size="mini" @click="edit(scope.row)">编辑</el-button>-->
                        <el-button style="color:red;"  type="text" size="mini" @click="cancellation(scope.row)">{{$t('button_nullify')}}</el-button>
                    </div>

                </template>
            </el-table-column>
        </el-table>

        <!--        分页器-->
        <div class="block">
            <div class="pages">
                <div class="choosepage flexother mrt20 fl">
                    <el-pagination
                            small

                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-sizes="[10, 20, 30, 40]"
                            :page-size="this.pageSize"
                            layout="total,sizes"
                            :total="this.total"
                    >
                    </el-pagination>
                    <el-pagination
                            small
                            :pager-count="5"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="this.currentPage"
                            :page-size="this.pageSize"
                            layout="prev, pager, next, jumper"
                            :total="this.total">
                    </el-pagination>
                </div>
            </div>
        </div>
            <div :class="baseerp+'div'">

            <el-dialog
                :close-on-click-modal="false"

                style="display: flex;justify-content: center;align-items: center"

                top="2.143rem"width="1130px"
                :title="title"
                :visible.sync="LeaveEntry"
                v-if="LeaveEntry"
                @close="close"
        >
            <attend-entry :leaveData="leaveData" @applicationList="applicationList" @close="close"> </attend-entry>
        </el-dialog>
                <el-dialog   :title="qjtitle" width="550px" :destroy-on-close="true" @close="closeIn" :close-on-click-modal="false" :show-close="false" v-if="LeaveinEntry" :visible.sync="LeaveinEntry">
                    <jia-bie :leaveper="leaveper" @close="closeIn" v-if="LeaveinEntry"></jia-bie>
                </el-dialog>
            </div>

            <div class="contentLeft">
                <reportdialog  ref="mydialog"></reportdialog>
                <eDialog ref="eDialog" :activePage="activePage"></eDialog>
            </div>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import AttendEntry from "./component/AttendEntry";
    import {mapActions} from "vuex";
    import reportdialog from "@/components/dialog"; // dialog
    import eDialog from "@/components/eDialog"; // dialog
    import {baseerp} from "@/utils/baseUrl";
    import JiaBie from "./component/JiaBie";

    // import tabTree from "./tabTree";
import LeftTree from "./../LeftTree";
    export default {
        name: "workManage",
        components:{
            JiaBie,
            eDialog,
            LeftTree,
            reportdialog,
            AttendEntry
            // tabTree
        },
        data(){
            return{
                activePage:"report/res/spread.vue",
                treeuserid:0,
                kaoqinList:[],
                kaoqini_id:0,
                startDate:'',
                endDate:'',
                kqdata:'',
                showTree:true,//显示树
                isright:true,//树显示按钮
                bianjiData:{},//编辑数据
                LeaveEntry:false,//显示弹框
                tableData: [],//列表数据
                currentPage:1,//页
                pageSize:10,//条
                total:0,//总数
                baseerp:'',//公共样式
                dateMonth:'',//月搜索
                peopleSearchdata:'',//人员搜索数据
                tableHeight:0,//列表高度
                cancellationid:0,//作废传入id
                title:'',//弹框标题
                jbdata:[],
                treedata:[],
                id:0,
                type:0,
                leaveData:{},

                qjtitle:'',
                leaveper:{},
                dateList:'',
                LeaveinEntry:false,
                socket:null
            }
        },
        activated(){
            this.onResize();
        },
        watch:{
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },




        },
        beforeDestroy(){
            if (this.socket!=null){
                // console.log('=======')

                this.socket.close()
            }
        },
        mounted(){
            this.getKqList()
            this.baseerp=baseerp
            this.$nextTick(()=>{
                this.onResize();

            })

            let month=(new Date().getMonth()+1)>10?new Date().getMonth()+1:'0'+(new Date().getMonth()+1)
            this.dateMonth=JSON.stringify(new Date().getFullYear())+'-'+month
            //获取假勤列表
            this.applicationList()
        },
        methods:{

            getRowClassName({row, rowIndex}) {//有children就显示箭头
                if (row.hasChildren==false) {
                    return 'row-expand-cover';
                }
            },
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-100
            },
            ...mapActions(["getCurrentMenuId"]),
            //月度报表
            async workovertime() {
                // this.formonth=data.forMonth

                let loading =this.$loading({lock:true,text:"正在加载数据,请稍候...",background:"rgba(0,0,0,0.5)"});
                // this.$refs.eDialog.showDialog({title:"报表",btn:{f:this.btn,l:{a:{title:"a",name:"a1"}}},parm:{type:'AttMonthRpt',mid:this.$route.meta.mid},w:800,h:600});
                document.addEventListener('click',function(e){
                    loading.close()
                })
                // console.log(data)
                // return
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                // console.log(this.i_kqtcid)
                let params = {
                    kqtcId: this.kaoqini_id,
                    date:this.dateMonth

                }
                let res = await API.time(params);
                if (res.code == 1) {
                    // console.log(res)
                    this.startDate=res.data.monthStartTime
                    this.endDate=res.data.monthEndTime
                    this.$refs.eDialog.showDialog({title:"加班汇总报表",parm:{type:'OvertimeRpt',mid:this.$route.meta.mid,arg:{startTime:this.startDate,endTime:this.endDate.substring(0,10)}},w:1024,h:768});
                    loading.close();
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});

                    this.$message.error(res.message);
                }
            },
            //加班报表
            async monthovertime() {
                // this.formonth=data.forMonth

                let loading =this.$loading({lock:true,text:"正在加载数据,请稍候...",background:"rgba(0,0,0,0.5)"});
                // this.$refs.eDialog.showDialog({title:"报表",btn:{f:this.btn,l:{a:{title:"a",name:"a1"}}},parm:{type:'AttMonthRpt',mid:this.$route.meta.mid},w:800,h:600});
                document.addEventListener('click',function(e){
                    loading.close()
                })
                // console.log(data)
                // return
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                // console.log(this.i_kqtcid)
                let params = {
                    kqtcId: this.kaoqini_id,
                    date:this.dateMonth

                }
                let res = await API.time(params);
                if (res.code == 1) {
                    // console.log(res)
                    this.startDate=res.data.monthStartTime
                    this.endDate=res.data.monthEndTime
                    this.$refs.eDialog.showDialog({title:"假勤月度报表",parm:{type:'offDutyRpt',mid:this.$route.meta.mid,arg:{startTime:this.startDate,endTime:this.endDate.substring(0,10),djmark:this.djmark}},w:1024,h:768});
                    loading.close();
                    // console.log(res)
                } else if (res.code == -2) {
                    this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$refs.mydialog.showDialog({type:"error",text:"报表加载失败!("+res.message+")",info:res.error});

                    this.$message.error(res.message);
                }
            },
            closeIn(){
                // console.log('closeIn')
                this.LeaveinEntry = false
                this.getKqList()
                // this.$refs.newCalender.btnup()
            },

            showData(val,kaoqini_id,djmark){
                // console.log(val,123)
                this.treedata = val
                this.djmark=djmark
                this.kaoqini_id=kaoqini_id
                if(val==''){
                    this.tableData=[]
                    this.total=0
                }else{
                    this.applicationList()

                }

            },
            cancellation(val){
                this.$confirm('是否作废', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.canceldetail(val.pid,val.userId)
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消作废'
                    })
                })
            },
            //关闭树
            closeTree(){
                this.isright=false
                this.showTree=false
                this.$refs.right.style='width:100%'
            },
            //显示树
            openTree(){
                this.isright=true
                this.showTree=true
                this.$refs.right.style='width:87%'

            },
            //考勤下拉框
            kqdataChange(val){
                // console.log(val)
                this.kqdata=val
                let kqdjmark=this.kaoqinList.filter(item=>{
                    return item.vc_tcname==val
                })
                this.djmark=kqdjmark[0].vc_djmark
                this.kaoqini_id=kqdjmark[0].i_id
                // this.getJqDetailList()

                // console.log(kqdjmark)
            },
            //搜索人员查询
            peopleSearch(val){
                // console.log(this.id)

                if(this.timer){
                    clearTimeout(this.timer)
                }
                    this.timer=setTimeout(()=>{
                            this.currentPage=1
                            this.peopleSearchdata=val
                            this.applicationList()

                    },500)


            },
            //搜索框月份搜索
            dateSearch(val){
                this.currentPage=1
                // this.dateMonth=val
                // console.log(val)
                this.applicationList()
            //
            //
            },
            // heightAuto(){
            //     this.tableHeight = window.innerHeight -  document.getElementById('body').getBoundingClientRect().top -100;
            // },
            // beforeDestroy() {
            //     window.removeEventListener('resize',this.heightAuto)
            // },

            //分页
            handleSizeChange(val) {
                // console.log(`每页 ${val} 条`);
                this.pageSize = val;    //动态改变
                this.applicationList()
            },
            handleCurrentChange(val) {
                this.currentPage = val;    //动态改变
                this.applicationList()
            },
            //编辑
            edit(val){
                this.leaveper.addId=val.pid
                this.leaveper.name=val.userName
                this.leaveper.id=val.userId
                this.leaveper.unit=val.unit
                this.leaveper.kqtc=val.kqtc
                this.leaveper.type='list'
                this.LeaveinEntry = true
                this.qjtitle=this.leaveper.name
            },
            //考勤方案接口
            async getKqList() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param = {
                    i_mid: this.mid,
                };
                let res = await API.getKqList(param);
                if (res.code == 1) {
                    this.kaoqinList=res.data
                    this.kqdata=res.data[0].vc_tcname
                    let kqdjmark=this.kaoqinList.filter(item=>{
                        return item.vc_tcname==this.kqdata
                    })
                    // this.kaoqini_id=kqdjmark[0].i_id
                    // this.djmark=kqdjmark[0].vc_djmark
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //新增
            add(){
                this.leaveData={
                    type:"new",
                    personId:this.treedata.type=='person'?this.treedata.value:'',
                    personName:this.treedata.type=='person'?this.treedata.label:'',
                    isrepair:0
                }

                // this.bianjiData=Object.assign({},'');
                this.title='新增'
                // this.type=0
                this.LeaveEntry=true
            },
            close(type=''){
                this.LeaveEntry=false
                this.applicationList()
            },
            //作废
            async canceldetail(id,userId) {
                let params = {
                 id:id,
                    userId:userId,
                }
                let res = await API.canceldetail(params);
                if (res.code == 1) {
                    // this.vc_name=res.data
                    this.applicationList()
                    this.$message({
                        message:res.message,
                        type: 'success'
                    });
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },

            //分页获取请假加班出差数据
            async applicationList() {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    pageSize:this.pageSize,
                    currentPage: this.currentPage,
                    date:this.dateMonth,
                    // date:'',
                    department:this.treedata.type=='depart'?this.treedata.value:null,
                    // userId:this.treeuserid
                    userId:this.treedata.type=='person'?this.treedata.value:null,
                    search:this.peopleSearchdata,

                }
                let res = await API.applicationList(params);
                if (res.code == 1) {
                    this.tableData=res.data.list
                        this.total=res.data.total
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .row-expand-cover .el-table__expand-icon {
        visibility: hidden;
    }
    .df{
        min-width: 39.286rem;
        width: 100%;
        height: 2.857rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 0.857rem;
    }
/deep/{
    .row-expand-cover .el-table__expand-icon {
        visibility: hidden;
    }
    .el-table--enable-row-transition{
        /*min-width: 64.286rem !important;*/
    }
    .el-button--text{
        padding: 0 !important;
        margin-left: 0 !important;
        margin-right: 10px;
    }
    .el-tabs__content{
        /*height: 90% !important;*/
        overflow: visible !important;
        height:calc(100% - 0.357rem) !important;
    }
}
    /deep/.is-leaf .cell .el-checkbox__input{
        display: none;
    }
    .m{
        padding-top: 1.429rem;
    }
    .flexother {
        display: flex;
        flex-flow: wrap;
        justify-content: space-between;
        align-items: center;
    }
    .fl{
        float: left;
        .el-button--primary{
            color: #efd773;
            background-color:white;
            border: 0;
            text-align: center;
            padding: 0;
            height: 2rem;
            width: 3.286rem;
            margin:0.857rem 0 0 0.714rem;
        }
    }

    .fr{
        float:right;
    }

    .cl{
        clear: both;
    }
.input{
    width: 14.286rem;
}
    /*.mrt20{*/
    /*    margin-top: 1.429rem;*/
    /*}*/
    .mrl20{
        margin-left: 1.429rem;
    }
    .mrb20{
        margin-right: 1.429rem;
    }
    .mrr20{
        margin-right: 1.429rem;
    }

    .chooseheader{
        width:100%;
    }

    .choosepage{
        /*min-width: 41.571rem;*/
        width:90%
    }
    .left{
        width: 17.857rem;
    }

    /deep/{
        .el-dialog{
            min-width: 900px;
        }
        .el-dialog__title,.el-dialog__headerbtn .el-dialog__close {
            color: white;
        }
        .el-table__expanded-cell[class*=cell]{
            padding: 5px;
        }
        .dtj{
            color: #409EFF;
        }
        .tg{
            color: #03cb45;
        }
        .spz{
            color: #ffbe06;
        }
        .wtg{
            color: #ff0500;
        }
        .yzf{
            color: #878787;
        }
    }

</style>